import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './shared/header/admin.component';
import { AuthComponent } from './shared/auth/auth.component';
import { LoginRouteGuard } from './services/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent, canActivate: [LoginRouteGuard],
    children: [
      {
        path: '',
        redirectTo: 'actividad',
        pathMatch: 'full'
      },
      {
        path: 'datosconsumidor',
        loadChildren: './pages/datosConsumidor/informes.module#InformesModule'
      },
      {
        path: 'actividad',
        loadChildren: './pages/listados/listados.module#ListadosModule'
      },
      {
        path: 'preguntas',
        loadChildren: './pages/preguntas/preguntas.module#PreguntasModule'
      },
      {
        path: 'encuestas',
        loadChildren: './pages/encuestas/encuestas.module#EncuestasModule'
      },
      {
        path: 'chat',
        loadChildren: './pages/chat/chat.module#ChatModule'
      }
    ]
  },
  { path: 'auth', component: AuthComponent, canActivate: [LoginRouteGuard], loadChildren: './auth/auth.module#AuthModule' },
  {
    path: '**',
    redirectTo: 'actividad'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts